export interface FlyerTaskDetails {
  signature: string;
  task: string;
  price: number;
  link: string;
  links: string[];
  photo: string;
  name: string;
  status: string;
}

export interface FlyerTask {
  id: string;
  status: string;
  details_flyer: FlyerTaskDetails;
  rewards: {
    stars: number;
  };
}

export interface FlyerResponse {
  status: string;
  tasks: FlyerTask[];
}

export enum FlyerStatus {
  Waiting = 'waiting',
  NotStarted = 'not_started',
  Active = 'active',
  Claim = 'claim',
  Check = 'check',
  Done = 'done',
}
